import api from '../services/api';
import { getCookie } from '../services/utils';

export const getOnlineMockExamCourses = (_: string, { id = null }: { id?: number | null } = {}) => {
    return api
        .get(getCookie('jid') ? '/available-online-mock-exam-courses' : '/online-mock-exam-courses', {
          params: {
            'filter[id]': id,
          }
        })
        .then((res) => res.data.data);
};

export const getOnlineMockExamCourse = (_: string, { id }: { id: number }) => {
    return api.get(`/online-mock-exam-courses/${id}`).then((res) => res.data.data);
};

export const getOnlineMockExamCourseLesson = (_key: string, { id, parentPassword }: { id: string, parentPassword: string | null }) => {
  return api
    .get(`/online-mock-exam-course-lessons/${id}`, {
      ...(parentPassword && {
        headers: { 'X-Parent-Password': parentPassword },
      }),
    })
    .then((res) => res.data.data);
};

export const getOnlineMockExamCourseLessonStatistics = (_key: string, { id }: { id: number }) => {
  return api.get(`/online-mock-exam-course-lessons/${id}/statistics`).then((res) => res.data.data);
}

export const getFreeLessons = () => {
    return api.get('/free-online-mock-exam-course-lessons').then((res) => res.data.data);
};

export const orderFreeLesson = (id: number) => {
    return api.post(`/free-online-mock-exam-course-lessons/${id}`).then((res) => res.data.data);
};

export const submitOnlineMockExamCourseLesson = (id: number, files: File[]) => {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files[]', file);
  });

  return api.post(`completed-online-mock-exam-course-lessons/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
